module.exports = __webpack_public_path__ + "img/soft-bg-5-dark.f49d29a0.png";